import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export function SurfaceCard({
	title,
	action,
	children,
	className
}: {
	title: string;
	action?: ReactNode;
	children: ReactNode;
	className?: string;
}) {
	return (
		<section className={cn('rounded-xl border border-subtle bg-surface p-4 shadow-panel', className)}>
			<div className="mb-3 flex items-start justify-between gap-3">
				<div>
					<h2 className="text-lg font-semibold text-primary">{title}</h2>
				</div>
				{action}
			</div>
			{children}
		</section>
	);
}
